import * as React from 'react';
import { Styleable, Style } from '../utils/styles';

export enum CardStyle {
  Default = 'bg-near-white black',
  Blank = 'bg-transparent',
  Gradient = 'bg-diagonal-gradient',
}

export interface CardProps extends Styleable {
  children: any;
  innerStyle?: Style;
}

export interface CardElement extends JSX.Element {
  props: CardProps;
}

export const Card = (props: CardProps) => (
  <div className="w-100 w-third-l aspect-ratio aspect-ratio--1x1 aspect-ratio--third-l relative">
    <div className="ma1 absolute absolute--fill bg-near-white black">
      <div className="flex flex-column justify-center absolute absolute--fill items-center pa2 pa4-l">
        {props.children}
      </div>
    </div>
  </div>
);
